import { requestForToken } from "../config/firebase";

export const getAuthToken = () => {
    return localStorage.getItem('admin_token');
}

export const getToken = async () => {
    if (
        typeof Notification === "undefined" ||
        !window.isSecureContext ||
        !("serviceWorker" in navigator)
    ) {
        return null;
    }

    try {
        let permission = Notification.permission;
        if (permission === "default") {
            permission = await Notification.requestPermission();
        }

        if (permission !== "granted") {
            return null;
        }

        return await requestForToken();
    } catch (error) {
        console.warn("Push notifications unavailable; continuing without a token.", error);
        return null;
    }
};

type JSONObject = {
    [key: string]: any;
};

export const prepareOrderData = (obj: any, isTopLevel = true): any => {
    if (Array.isArray(obj)) {
        return obj.map(item => prepareOrderData(item, false));
    } else if (typeof obj === 'object' && obj !== null) {
        const cleaned: JSONObject = {};

        for (const key in obj) {
            if (['id', '_id', '__v', 'user_id', 'status','StoreLoc'].includes(key)) {
                continue;
            }

            // Rename only the top-level SalesOrder key
            const newKey = (isTopLevel && key === 'SalesOrderRequisition') ? 'InquireNo' : key;
            cleaned[newKey] = prepareOrderData(obj[key], false);
        }

        return cleaned;
    }

    return obj;
}

export const prepareReturnOrderData = (obj: any, isTopLevel = true): any => {
    if (Array.isArray(obj)) {
        return obj.map(item => prepareReturnOrderData(item, false));
    } else if (typeof obj === 'object' && obj !== null) {
        const cleaned: JSONObject = {};
        for (const key in obj) {
            if (['id', '_id', '__v', 'user_id', 'status','image_urls','ReturnOrderNo','createdAt','images','updatedAt','ReturnReason','ReturnOrderReason'].includes(key)) {
                continue;
            }
             const value = obj[key];

              if ((key === 'ReqDate' || key === 'ReturnDate') && typeof value === 'string') {
                cleaned[key] = new Date(value).toISOString().split('T')[0]; // "YYYY-MM-DD"
                continue;
            }

            // Convert NetValue and OrderQty to strings
            if ((key === 'NetValue' || key === 'OrderQty') && value != null) {
                cleaned[key] = String(value);
                continue;
            }

            // Rename only the top-level SalesOrder key
            const newKey = (isTopLevel && key === 'SalesOrderRequisition') ? 'InquireNo' : key;
            cleaned[newKey] = prepareReturnOrderData(obj[key], false);
        }

        return cleaned;
    }

    return obj;
}
